import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminHeaders = () => ({
  "X-Admin-Token": localStorage.getItem("zentra-admin-token") || "",
});
